var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoadListingWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 8.428V19.67c0 .493-.134.977-.388 1.404a2.852 2.852 0 01-1.056 1.027l-10.112 5.621a2.933 2.933 0 01-.694.28v-13.52l12.042-7.098c.136.33.208.685.208 1.044zm-1.142-2.235a2.903 2.903 0 00-.302-.196L14.444.377a2.95 2.95 0 00-2.888 0L7.81 2.458 19.503 9.35l5.355-3.157zm-6.832 4.028L6.29 3.303 1.444 5.997c-.105.06-.206.125-.302.196L13 13.183l5.026-2.962zM.208 7.384l12.042 7.098v13.52a2.937 2.937 0 01-.694-.28l-10.112-5.62a2.852 2.852 0 01-1.056-1.028A2.752 2.752 0 010 19.67V8.428c0-.359.071-.713.208-1.044z",
    fill: "#fff"
  })));
}

export default SvgLoadListingWhite;